import Label from 'Components/Label';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { setExpedienteId, setId } from '../../../../redux/slices';
import CreditoService from 'Services/Http/Credito.service';
import { formatCurrency } from 'Utils/Functions';
import SearchBar from 'Components/SearchBar';
import Paginador from 'Components/Paginador';
import ProgressBar from 'Components/ProgressBar';

const ListarCreditosComponente = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [clientes, setClientes] = useState([]);
  const [showPaginador, setShowPaginador] = useState(true);
  const [loader, setLoader] = useState(false);

  const getAllClientes = async (page) => {
    setLoader(true);
    try {
      setClientes([]);
      const response = await CreditoService.creditos({ page });
      createRows(response.data);
    } catch (e) {
      console.log(e);
      setLoader(false);
    }
  };

  const activeExpedient = (uuid, id, idExpediente) => {
    console.log(idExpediente);
    const url = '/main/validacion/' + uuid + '/autorizado';
    const dataId = [];
    dataId[uuid] = id;
    dispatch(setId(dataId));
    dispatch(setExpedienteId(idExpediente));
    goTo(url);
  };

  const goTo = (url) => {
    navigate(url);
  };
  const createRows = (rows) => {
    let data = rows.map((item, index) => (
      <tr
        key={'clientes-row-' + index}
        className="odd:bg-white even:bg-blue-100 border-b hover:bg-blue-300 hover:cursor-pointer"
        onClick={() => activeExpedient(item.uuid, item.id, item.idExpediente)}>
        <td className="px-6 py-4">{item.id}</td>
        <td className="px-6 py-4">{item.nombreCompleto}</td>
        <td className="px-6 py-4">{item.folioCredito}</td>
        <td className="px-6 py-4">
          {item.autorizacion ? moment(item.autorizacion).format('DD/MM/YYYY') : ''}
        </td>
        <td className="px-6 py-4">{formatCurrency(item.montoSolicitado)}</td>
        <td className="px-6 py-4">{formatCurrency(item.montoAprovado)}</td>
        <td className="px-6 py-4">
          {item.dispercion ? moment(item.dispercion).format('DD/MM/YYYY') : ''}
        </td>
        <td className="px-6 py-4">
          {item.dispersado ? moment(item.dispersado).format('DD/MM/YYYY') : ''}
        </td>
        <td className="px-6 py-4">{item.asignado}</td>
      </tr>
    ));
    setClientes(data);
    setLoader(false);
  };
  const find = async (text) => {
    setClientes([]);
    setShowPaginador(false);
    const response = await CreditoService.creditos(text);
    createRows(response.data);
  };
  const reload = () => {
    setShowPaginador(true);
  };
  return (
    <>
      <Label text={'Creditos'} />
      <div className="flex flex-col grid grid-cols-1 md:grid md:grid-flow-col md:grid-cols-2 md:flex-row gap-3 my-3 justify-stretch">
        <div className="flex order-2 md:order-1">
          <SearchBar find={find} reload={reload} />
        </div>
      </div>
      <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
        <table className="w-full text-sm text-left rtl:text-right text-black">
          <thead className="text-xs text-white uppercase bg-blue-500">
            <tr>
              <th scope="col" className="px-6 py-3">
                #
              </th>
              <th scope="col" className="px-6 py-3">
                Nombre completo
              </th>
              <th scope="col" className="px-6 py-3">
                Credito
              </th>
              <th scope="col" className="px-6 py-3">
                Autorizado
              </th>
              <th scope="col" className="px-6 py-3">
                Monto Solicitado
              </th>
              <th scope="col" className="px-6 py-3">
                Monto Aprovado
              </th>
              <th scope="col" className="px-6 py-3">
                Dispercion
              </th>
              <th scope="col" className="px-6 py-3">
                Dispersado
              </th>
              <th scope="col" className="px-6 py-3">
                Asignado
              </th>
            </tr>
          </thead>
          <tbody>{clientes}</tbody>
          <tfoot>
            <tr>
              {showPaginador ? (
                <td colSpan={8}>
                  <Paginador onChange={getAllClientes} />
                </td>
              ) : (
                ''
              )}
            </tr>
          </tfoot>
        </table>
        {loader ? <ProgressBar /> : ''}
      </div>
    </>
  );
};

export default ListarCreditosComponente;
